import React, { FC } from 'react';
import styles from './ItemPartnerImage.module.scss'

interface ItemPartnerImageProps{
    image: string;
    coinName?: string;
    coinSecondName?: string;
    coinPrice?: string;
}

const ItemPartnerImage:FC<ItemPartnerImageProps> = ({image, coinName, coinSecondName, coinPrice}) => {
    return (
        <div className={styles.coin__main}>
            <div className={styles.coin__wrapper}>
                <div className={styles.coin__image}>
                    <img src={image} width={120} height={40} loading="lazy" alt="" />
                </div>
            </div>
        </div>
    );
};

export default ItemPartnerImage;